/**
 * Utility di formattazione per la UI.
 * Specifica italiana (it-IT): 1.234,56 € e "7 luglio 2026".
 */

import { formatEuro as _formatEuro, formatDateISO as _formatDateISO } from '@shared/format.js';

export const formatEuro = _formatEuro;
export const formatDateISO = _formatDateISO;

/** Restituisce una stringa HTML-safe (escapa < > & ") */
export function esc(str) {
  return String(str ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;');
}

/** Abbrevia un importo in migliaia (es. 1234 -> '1,23 k€') */
export function abbrevEuro(value) {
  const n = Number(value) || 0;
  if (Math.abs(n) >= 1000) return `${(n / 1000).toFixed(2).replace('.', ',')} k€`;
  return `${n.toFixed(2).replace('.', ',')} €`;
}
